import { render, staticRenderFns } from "./Allocations.vue?vue&type=template&id=ef008b00&"
import script from "./Allocations.vue?vue&type=script&lang=js&"
export * from "./Allocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports